import React, { useEffect, useState } from 'react';
import { fetchAllSnippets } from '../lib/sanity';
import '../pages/Snippets.css';

function SnippetsList() {
  const [snippets, setSnippets] = useState([]);

  useEffect(() => {
    const loadSnippets = async () => {
      const fetchedSnippets = await fetchAllSnippets();
      setSnippets(fetchedSnippets);
    };
    loadSnippets();
  }, []);

  const renderMedia = (snippet) => {
    if (!snippet.mediaType) {
      return <div>No media type specified</div>;
    }

    switch (snippet.mediaType) {
      case 'single':
        if (!snippet.media) return <div>No media found</div>;
        
        return (
          <>
            {snippet.media.type === 'video' ? (
              <video
                src={snippet.media.video.asset.url}
                alt={snippet.media.alt}
                autoPlay
                loop
                muted
                playsInline
                className="snippet-image"
              />
            ) : (
              <img
                src={snippet.media.image.asset.url}
                alt={snippet.media.alt}
                className="snippet-image"
              />
            )}
          </>
        );

      case 'dual':
        if (!snippet.dualImages) return <div>No dual images found</div>;
        
        return (
          <div className="dual-images-container">
            <div className="large-image-container">
              <img
                src={snippet.dualImages.largeImage.asset.url}
                alt={snippet.dualImages.largeImageAlt}
                className="large-image"
              />
              <div className="title-container">
                {snippet.name && (
                  <h3 className="snippet-title">
                    {snippet.name}
                  </h3>
                )}
                <span className="snippet-year">{new Date(snippet.date).getFullYear()}</span>
              </div>
            </div>
            <div className="small-image-container">
              <img
                src={snippet.dualImages.smallImage.asset.url}
                alt={snippet.dualImages.smallImageAlt}
                className="small-image"
              />
            </div>
          </div>
        );

      case 'dualVideos':
        if (!snippet.dualVideos) return <div>No dual videos found</div>;
        
        return (
          <div className="dual-videos-container">
            <div className="large-video-container">
              <video
                src={snippet.dualVideos.largeVideo.asset.url}
                alt={snippet.dualVideos.largeVideoAlt}
                autoPlay
                loop
                muted
                playsInline
                className="large-video"
              />
              <div className="title-container">
                {snippet.name && (
                  <h3 className="snippet-title">
                    {snippet.name}
                  </h3>
                )}
                <span className="snippet-year">{new Date(snippet.date).getFullYear()}</span>
              </div>
            </div>
            <div className="small-video-container">
              <video
                src={snippet.dualVideos.smallVideo.asset.url}
                alt={snippet.dualVideos.smallVideoAlt}
                autoPlay
                loop
                muted
                playsInline
                className="small-video"
              />
            </div>
          </div>
        );

      case 'mixed':
        if (!snippet.mixedMedia) return <div>No mixed media found</div>;
        
        const renderMixedMedia = (mediaObj, className) => {
          if (mediaObj.type === 'video') {
            return (
              <video
                src={mediaObj.video.asset.url}
                alt={mediaObj.alt}
                autoPlay
                loop
                muted
                playsInline
                className={className}
              />
            );
          } else {
            return (
              <img
                src={mediaObj.image.asset.url}
                alt={mediaObj.alt}
                className={className}
              />
            );
          }
        };

        return (
          <div className="mixed-media-container">
            <div className="large-media-container">
              {renderMixedMedia(snippet.mixedMedia.largeMedia, 'large-media')}
              <div className="title-container">
                {snippet.name && (
                  <h3 className="snippet-title">
                    {snippet.name}
                  </h3>
                )}
                <span className="snippet-year">{new Date(snippet.date).getFullYear()}</span>
              </div>
            </div>
            <div className="small-media-container">
              {renderMixedMedia(snippet.mixedMedia.smallMedia, 'small-media')}
            </div>
          </div>
        );

      default:
        return <div>Unknown media type: {snippet.mediaType}</div>;
    }
  };

  return (
    <div className="snippets-list">
      <div className="snippets-list-container">
        {snippets.map((snippet, index) => {
          const isAlternate = index % 2 === 1;
          return (
            <div 
              key={index} 
              className={`snippet-item ${isAlternate ? 'snippet-item-reverse' : ''}`}
            >
              <div className="snippet-image-container">
                {renderMedia(snippet)}
                {snippet.mediaType === 'single' && (
                  <div className="title-container">
                    {snippet.name && (
                      <h3 className="snippet-title">
                        {snippet.name}
                      </h3>
                    )}
                    <span className="snippet-year">{new Date(snippet.date).getFullYear()}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SnippetsList; 